module.exports = __webpack_public_path__ + "img/employee-chat-image.cd626a0.png";